import { GDFFrontType, GDFRecordType } from '../../../gdf/type';
import { StyleFactory } from '../styling';

export const frontLayers: StyleFactory = (baseId, settings) => {
    return [
        {
            type: 'line',
            filter: ['all', ['==', ['get', 'recordType'], GDFRecordType.front], ['==', ['geometry-type'], 'LineString']],
            id: baseId + '-front-lines',
            source: baseId,
            paint: {
                'line-blur': 8,
                'line-width': [
                    'case',
                    ['==', ['get', 'front'], GDFFrontType.stationary], 48,
                    ['==', ['get', 'front'], GDFFrontType.stationaryCW], 48,
                    ['==', ['get', 'front'], GDFFrontType.stationaryWC], 48,
                    32
                ],
                //prettier-ignore
                'line-pattern': ['image', [
                    'case',
                    ['==', ['get', 'front'], GDFFrontType.cold], 'front-cold',
                    ['==', ['get', 'front'], GDFFrontType.stationaryCC], 'front-cold',
                    ['==', ['get', 'front'], GDFFrontType.warm], 'front-warm',
                    ['==', ['get', 'front'], GDFFrontType.stationaryWW], 'front-warm',
                    ['==', ['get', 'front'], GDFFrontType.stationary], 'front-stationary',
                    ['==', ['get', 'front'], GDFFrontType.occluded], 'front-occluded',
                    ['==', ['get', 'front'], GDFFrontType.tropicalWave], 'front-tropical-wave',
                    ['==', ['get', 'front'], GDFFrontType.surfaceTrough], 'front-surface-through',
                    ['==', ['get', 'front'], GDFFrontType.squallLine], 'front-squall',
                    ['==', ['get', 'front'], GDFFrontType.dryline], 'front-dry-line',
                    ['==', ['get', 'front'], GDFFrontType.stationaryCW], 'front-cold-warm',
                    ['==', ['get', 'front'], GDFFrontType.stationaryWC], 'front-warm-cold',
                    ''
                ]],
            }
        },
        {
            type: 'line',
            filter: [
                'all',
                ['==', ['get', 'recordType'], GDFRecordType.front],
                ['==', ['geometry-type'], 'LineString'],
                ['==', ['get', 'front'], GDFFrontType.isobarPressureLine]
            ],
            id: baseId + '-front-isobar',
            source: baseId,
            paint: {
                'line-width': 1,
                'line-color': 'rgb(128,128,128)'
            }
        },
        {
            type: 'symbol',
            filter: ['all', ['==', ['get', 'recordType'], GDFRecordType.front], ['==', ['geometry-type'], 'Point']],
            id: baseId + '-front-points',
            source: baseId,
            layout: {
                'text-field': [
                    'format',
                    ['case', ['==', ['get', 'front'], GDFFrontType.highCenter], 'H', 'L'],
                    '\n',
                    ['get', 'reading'],
                    { 'font-scale': 0.5 }
                ],
                'text-allow-overlap': true,
                'text-font': ['Metropolis Bold'],
                'text-size': 25
            },
            paint: {
                'text-color': ['case', ['==', ['get', 'front'], GDFFrontType.highCenter], 'rgb(0,0,127)', 'rgb(192,0,0)']
            }
        },
        {
            minzoom: 3,
            type: 'symbol',
            filter: [
                'all',
                ['==', ['get', 'recordType'], GDFRecordType.front],
                ['==', ['geometry-type'], 'LineString'],
                ['==', ['get', 'front'], GDFFrontType.isobarPressureLine]
            ],
            id: baseId + '-front-isobar-label',
            source: baseId,
            layout: {
                'text-field': ['get', 'reading'],
                'symbol-placement': 'point',
                'text-font': ['Open Sans Regular'],
                'text-offset': [0, 1],
                'text-allow-overlap': true,
                'text-size': 10
            },
            paint: {
                'text-color': ['global-state', 'text-color']
            }
        }
    ];
};
